module.exports = __webpack_public_path__ + "static/media/green-check.9f549f24.svg";